import { getWorkspaceSettingsForPlan } from "@functions/workspacePlans";

import workspaceApi from "../backendapi/workspaceApi";

export function getWorkspacePlanLimits(plan, isCreditBased) {
    const usage = getWorkspaceSettingsForPlan(plan, isCreditBased);
    return {
        sources: usage?.limit?.sources,
        transforms: usage?.limit?.transforms,
        variantsPerImage: usage?.limit?.variantsPerImage,
        collaborators: usage?.limit?.collaborators,
        projects: usage?.limit?.projects,
        inferenceQuota: usage?.inference?.quota,
        trainingQuota: usage?.train?.quota,
        trainingReloads: usage?.train?.reload || 0,
        autoLabelCredits: usage?.auto_label?.monthly_quota,
        includedCredits: usage?.ubp?.includedCredits,
        pricePerCredit: usage?.ubp?.pricePerCredit,
        price: usage?.price,
        allowPrivateProjects: usage?.features?.allowPrivateProjects
    };
}

export async function canReceiveExpertConsultation(workspaceId) {
    return await workspaceApi.canReceiveExpertConsultation(workspaceId);
}
